const columnDefs: any = {
  Checkbox: {
    prop: 'Checkbox',
    name: '',
    hidden: false,
    visible: true,
    width: 40,
    sortable: false,
    filterable: false,
    resizeable: false,
    checkboxable: true,
    template: 'checkbox',
  },
  ID: {
    prop: 'ID',
    name: 'Field ID',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  FIELDTYPE: {
    prop: 'FIELDTYPE',
    name: 'Field Type',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  FIELDNAME: {
    prop: 'FIELDNAME',
    name: 'Field Name',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  DESCRIPTION: {
    prop: 'DESCRIPTION',
    name: 'Field Description',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  BOFIELDNAME: {
    prop: 'BOFIELDNAME',
    name: 'Database Field',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  REQUIRED: {
    prop: 'REQUIRED',
    name: 'Required?',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
  MAXCHARACTERS: {
    prop: 'MAXCHARACTERS',
    name: 'Max characters?',
    hidden: false,
    visible: true,
    width: 250,
    sortable: true,
    filterable: true,
    template: 'value',
  },
};

export default columnDefs;
